<template>
  <div class="app-bar">
    <div :showLightAppBar="showLightAppBar" class="app-bar-span-solid" />
    <div class="navigation-drawer-toggler mt-8 mr-5 ml-5">
        <v-btn icon @click="drawer = !drawer">
            <font-awesome-icon size="2x" :icon="['fas', drawer ? 'times' : 'bars']" 
                                :class="[useLightIcon ? 'navigation-bar-icon-light' : 'navigation-bar-icon-dark']" 
            />
        </v-btn>
    </div>
    <!-- 
        We have to set display: none when the drawer is closed because on mobile theres a bug where
        the drawer is closed but the width on the drawer is added to the overall application
    -->
    <v-navigation-drawer
        v-model="drawer"
        fixed
        temporary
        right
        :style="{ display: drawer ? '' : 'none'}"
        width="100%"
    >
        <div class="navigation-drawer-content">
            <div>
                <router-link v-for="route in routes" 
                    :key="route.to" 
                    :to="route.path"
                    class="router-link-base router-link"
                >
                    <div v-if="route.meta.showInNavigation"
                        class="mb-3"
                    >
                        <span class="mr-5">{{ route.meta.routeNum }}</span>
                        <span>{{ route.name }}</span>
                    </div>
                </router-link>
            </div>
        </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import routes from '@/router/routes'

export default {
    name: 'NavigationMobile',
    data: function() {
        return {
            drawer: false,
            routes: routes
        }
    },
    computed: {
        showLightAppBar() {
            return this.$route.name !== "Home" && !this.drawer; 
        },
        useLightIcon() {
            return this.$route.name === "Home" || this.drawer; 
        },
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/global.scss';

$translation-command-bar-height: 50px;

.navigation-bar-icon-light {
    color: $contentText;
}

.navigation-bar-icon-dark {
    color: $navigationBackground;
}

.app-bar {
    height: $app-bar-height-mobile;
}

.app-bar-span-solid[showLightAppBar="true"] {
    background-color: $applicationBackground;
}

.app-bar-span-solid[showLightAppBar="true"] {
    height: $app-bar-height-mobile;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: $applicationBackground;
    opacity: 0.97;
    z-index: 5;
}

.company-name-drawer {
    position: fixed;
    top: 0;
    width: 100%;
    justify-content: center;
}

.navigation-drawer-toggler {
    position: fixed;
    top: 0;
    z-index: 15; // large number to stay as the front-most item (even after navigation drawer has been expanded)
}

.navigation-drawer-content {

    //height: calc(90% - #{$translation-command-bar-height});
    overflow-x: auto;

    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.router-link {
    font-size: 1.3rem;
    letter-spacing: 1.5px;
}

@media screen and (min-width: 350px)
{
    .router-link {
        font-size: 1.7rem;
    }
}

@media screen and (min-width: 1000px)
{
    .router-link {
        font-size: 2rem;
    }
}

.v-navigation-drawer {
    background-color: $navigationBackground !important;
    opacity: 0.96 !important;
}

</style>